"use strict";
import {on, findIn} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";

export function init () {
    onFind('.js-ajax-form', function (ajaxForm) {
        let offset = matchMedia('(max-width: 767px)').matches ? 60 : 100;
        on('fetch.ajax-form', function () {
            let result = findIn('.js-ajax-form__result', ajaxForm);
            let scrollOffset = result.getBoundingClientRect().top + window.scrollY - offset;
            if (window.scrollY > scrollOffset) {
                window.scrollTo({
                    top: scrollOffset,
                    behavior: 'smooth'
                });
            }
        }, ajaxForm);
    });
}